import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import imgIcon1 from "../../../../assets/images/Clip path group.png";
import imgIcon2 from "../../../../assets/images/Clip path group (1).png";
import imgIcon3 from "../../../../assets/images/Clip path group (3).png";
import imgIcon4 from "../../../../assets/images/Clip path group (2).png";
// import Community from "../../../../assets/images/community_new.png";
import PropTypes from "prop-types";
import imgIcon5 from "../../../../assets/images/Group.png";
import formIcon from "../../../../assets/images/register.png";
import preferenceIcon from "../../../../assets/images/set your prefrences.png";
import storeIcon from "../../../../assets/images/set up your digital store front.png";
import coffeeIcon from "../../../../assets/images/sit back & relax.png";
import tickIcon from "../../../../assets/images/tickIcon34.svg";
import crossIcon from "../../../../assets/images/crossIcon34.svg";
import PublicLayout from "web/components/PublicLayout";
import AOS from "aos";
import LandingFooter from "web/pages/public/landing-page/LandingFooter";
import {
  Container,
  Wrapper,
} from "web/pages/public/landing-page/PalletSupplier/PalletSupplierStyled";
import GetQuoteComponent from "../StartPage/GetQuote";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logoutAdmin } from 'redux/actions/admin';
import { logoutClearRedux } from 'redux/actions/auth';

const data = [
  {
    title: "Uncover New Opportunities",
    icon: imgIcon1,
    description: [
      "Whether direct from buyers on the marketplace, or via our managed services team, receive targeted opportunities that fit your needs.",
    ],
  },
  {
    title: "Inventory Visibility, Privacy Assured",
    icon: imgIcon2,
    description: [
      " Let PalletTrader be your digital storefront! Advertise your inventory on the marketplace and receive offers from qualified buyers.",
    ],
  },
  {
    title: "Quick Payment Terms",
    icon: imgIcon3,
    description: [
      " Say goodbye to credit terms. Payment is automatically initiated after the POD is posted to the system.",
    ],
  },
  {
    title: "Set it & Forget it",
    icon: imgIcon4,
    description: [
      "No need to check back, the system will notify you when an opportunity exists.",
    ],
  },
  {
    title: "Free To Use",
    icon: imgIcon5,
    description: [
      "No subscription for 12 months, only pay a small transaction fee when you transact.",
    ],
  },
];

const CardDetails = ({ item, index, isOpen, onOpen, onClose }) => {
  const ref = useRef();
  const dispatch = useDispatch();
  let history = useHistory();

  useEffect(() => {
    let token = localStorage.getItem('token')
    let isAdminOrUserAccount = localStorage.getItem('accountType')
    if (isAdminOrUserAccount && token) {
      if (isAdminOrUserAccount === 'Admin') history.push('/admin')
      else history.push('/dashboard')
    } else {
      dispatch(logoutAdmin())
      dispatch(logoutClearRedux())
      localStorage.clear()
      sessionStorage.clear()
    }
  }, [])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, onClose]);

  return (
    <>
      <div className="card" data-aos="fade-right" data-aos-delay={index * 300} ref={ref}>
        <div className="text-box">
          <h4>{item?.title}</h4>
          <p onClick={onOpen}>Read more</p>
          <div className={`hover-box ${isOpen ? 'active' : ''}`}>
            <img
              src={crossIcon}
              onClick={onClose}
            />
            <h4>{item?.title}</h4>
            <ul>
              {item?.description?.map((desc, descIndex) => (
                <li key={index + "description-" + descIndex}>
                  <img src={tickIcon} /> {desc}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="img-box">
          {typeof item.icon === "function" ? (
            item.icon()
          ) : (
            <img src={item.icon} alt="icon" />
          )}
        </div>
      </div>
    </>
  );
};

CardDetails.propTypes = {
  item: PropTypes.object,
  index: PropTypes.number,
  isOpen: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
};


const PalletSupplier = () => {
  const location = useLocation();
  const howRef = useRef(null);
  const benefitsRef = useRef(null);
  const founderRef = useRef(null);
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 320,
      once: true,
    });
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (location.hash === "#how") {
      if (howRef.current) {
        // howRef.current.scrollIntoView({ behavior: 'smooth' });
        const element = howRef.current;
        const yOffset = -80; // Adjust the offset as needed
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [location]);

  useEffect(() => {
    if (location.hash === "#benefits") {
      if (benefitsRef.current) {
        // benefitsRef.current.scrollIntoView({ behavior: 'smooth' });
        const element = benefitsRef.current;
        const yOffset = -80; // Adjust the offset as needed
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [location]);

  useEffect(() => {
    if (location.hash === "#founder") {
      if (founderRef.current) {
        // founderRef.current.scrollIntoView({ behavior: 'smooth' });
        const element = founderRef.current;
        const yOffset = -80; // Adjust the offset as needed
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [location]);

  let history = useHistory();
  const signUp = () => {
    localStorage.setItem("guestUser", false);
    localStorage.setItem("postInventory", false);
    localStorage.setItem("memberShipType", "");
    history.push("/registration");
  };
  const contactUs = () => {
    history.push("/contact-us");
  };

  const founderCircle = () => {
    history.push("founders-circle");
  };

  const [openIndexes, setOpenIndexes] = useState([]);

  const toggleAccordion = (index) => {
    if (openIndexes.includes(index)) {
      setOpenIndexes(openIndexes.filter((i) => i !== index));
    } else {
      setOpenIndexes([...openIndexes, index]);
    }
  };

  const [openIndex, setOpenIndex] = useState(null);

  const handleOpen = (index) => {
    setOpenIndex(index);
  };

  const handleClose = () => {
    setOpenIndex(null);
  };

  const benefits = [
    {
      title: "Reach new markets",
      content:
        "Sell components or pallets to local, regional, and national depots or pallet users who were previously unreachable.",
    },
    {
      title: "Private groups",
      content:
        "PalletTrader enables private transactions. Post your pallets to the marketplace, or to one of your private groups.",
    },
    {
      title: "Seamless sales management",
      content: " Assign multiple users to your account so they can post and manage their own book of business.",
    },
    {
      title: "End-to-end transaction visibility",
      content:
        "From the time a bid or offer has been accepted until pick-up or delivery, buyers and sellers have complete transaction visibility.",
    },
    {
      title: "Secure payments",
      content:
        "PalletTrader provides secured payment methods, with activity reporting. Quickly convert cold calls into qualified transactions.",
    },
    {
      title: "Identify market trends",
      content:
        "PalletTrader provides market intelligence. Know where the market is at, and where it's going. You'll buy and sell smarter.",
    },
    // { title: "KPI dashboard", content: "Content for KPI dashboard" },
    {
      title: "Identify new partners",
      content: "PalletTrader will push you new opportunities in your area, ultimately expanding your network of partners to do business with.",
    },
    {
      title: "Privacy protected",
      content:
        "To ensure privacy, brokers will have their own unique profile. Buy or sell without disclosing your customers or sources.",
    },
    {
      title: "Qualified buyers and sellers",
      content:
        "PalletTrader will qualify buyers and sellers. Our vetting process ensures members are the highest-quality trading partners.",
    },
  ];


  return (
    <>
      <Helmet title="PalletTrader | Pallet Supplier Solutions">
        <meta
          name="description"
          content="PalletTrader helps suppliers to seamlessly sell pallets. Reach more buyers, acesss targeted opportunities, manage inventory, and grow your pallet business with ease."
        />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/pallet-supplier-and-broker-solutions" />
      </Helmet>
      <PublicLayout transparentHeader={true}>
        <Container>
          <Wrapper>
            <section className="banners">
              <div className="quotes">
                <GetQuoteComponent />
              </div>
              <div
                className="banner-texts"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <h2>One Platform.</h2>
                <h2 className="mb-4">Unlimited Opportunity</h2>
                <p>
                  PalletTrader is the leading digital marketplace and order
                  management platform for transacting pallets. Founded by pallet
                  industry experts, it was designed to meet the needs of the
                  supplier community.
                </p>
              </div>
            </section>

            {/* <section className="efficiency01">
              <div className="process">
                <div className="process_title">
                  <h2>Advantages for Suppliers of All Sizes.</h2>
                </div>
                <div
                  className="box-3-wrp"
                  data-aos="fade-right"
                  data-aos-delay="000"
                >
                  <div className="box-info">
                    <div className="img-bg">
                      <img src={imgIcon1} />
                    </div>
                    <div className="text-bg">
                      <h3>Uncover New opportunities</h3>
                    </div>
                  </div>

                  <div
                    className="box-info"
                    data-aos="fade-right"
                    data-aos-delay="300"
                  >
                    <div className="img-bg">
                      <img src={imgIcon2} />
                    </div>
                    <div className="text-bg">
                      <h3>Inventory Visibility Privacy Assured</h3>
                    </div>
                  </div>
                  <div
                    className="box-info"
                    data-aos="fade-right"
                    data-aos-delay="600"
                  >
                    <div className="img-bg">
                      <img src={imgIcon3} />
                    </div>
                    <div className="text-bg">
                      <h3>Quick Payment Terms.</h3>
                    </div>
                  </div>
                  <div
                    className="box-info"
                    data-aos="fade-right"
                    data-aos-delay="900"
                  >
                    <div className="img-bg">
                      <img src={imgIcon4} />
                    </div>
                    <div className="text-bg">
                      <h3>Setlt & Forget It</h3>
                    </div>
                  </div>
                  <div
                    className="box-info"
                    data-aos="fade-right"
                    data-aos-delay="1200"
                  >
                    <div className="img-bg">
                      <img src={imgIcon5} />
                    </div>
                    <div className="text-bg">
                      <h3>Free To Use</h3>
                    </div>
                  </div>
                </div>
              </div>
              <div className="boxes">
                <button onClick={signUp}>REGISTER NOW</button>
                <button
                  className="btn2"
                  button
                  onClick={() => {
                    history.push("/search-inventory");
                  }}
                >
                  SEARCH MARKETPLACE
                </button>
              </div>
            </section> */}

            <div className="what_you_get">
              <div className="what_you_get-container">
                <h2>Advantages for Suppliers of All Sizes.</h2>
                {/* <p>All the Tools. All the Technology. It's All You Need</p> */}

                <div className="cards-container">
                  {data?.map((item, index) => (
                    <CardDetails
                      key={"card-item" + index}
                      item={item}
                      index={index}
                      isOpen={openIndex === index}
                      onOpen={() => handleOpen(index)}
                      onClose={handleClose}
                    />
                  ))}
                </div>
              </div>
            </div>

            <section className="our_expertise">
              <div className="expertise_overlay join">
                <div data-aos="fade-up" data-aos-delay="100">
                  <h2>
                    Unlock Endless Opportunities.
                    <h2 className="mb-2">Join the Community Today.</h2>
                  </h2>
                  <p className="max-w">
                    By joining PalletTrader, you will become part of the
                    fastest growing online network of pallet suppliers, gaining
                    access to new opportunities and bringing ultimate visibility
                    to your operation. Our goal is to drive new sales to your
                    business!
                  </p>
                  <div className="grid">
                    <button onClick={signUp}>JOIN THE COMMUNITY NOW</button>
                    <button onClick={contactUs}>CONTACT US</button>
                  </div>
                </div>
                {/* <div className="digital_supplier_img"> */}
                {/* <img src={Community} alt="icon" data-aos="fade-down" data-aos-delay="100" /> */}
                {/* </div> */}
              </div>
            </section>

            <div className="main" id="how" ref={howRef}>
              <h2 className="header">How It Works</h2>
              <p className="main_text">
                Completely transform your sales strategy in four easy steps
              </p>
              <div className="list-wrapper">
                <div
                  className="item-container first"
                  data-aos="flip-up"
                  data-aos-delay="000"
                >
                  <div className="number-box">
                    <span className="number">1</span>
                    <span className="number-shadow">1</span>
                  </div>
                  <div className="item-wrap">
                    <div className="icon-box">
                      <img src={formIcon} />
                      <p>Register</p>
                    </div>
                    <div className="bg-wrap">
                      <div className="traingle"></div>
                      <div className="description-box">
                        Registration takes minutes, with speedy account approval.
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="item-container second"
                  data-aos="flip-up"
                  data-aos-delay="200"
                >
                  <div className="number-box">
                    <span className="number">2</span>
                    <span className="number-shadow">2</span>
                  </div>
                  <div className="item-wrap">
                    <div className="icon-box">
                      <img src={preferenceIcon} />
                      <p>Set Your Preferences</p>
                    </div>
                    <div className="bg-wrap">
                      <div className="traingle"></div>
                      <div id="description2" className="description-box">
                        Tell us about yourself! Set your account preferences for
                        easier posting and more targeted bid opportunities.
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="item-container third"
                  data-aos="flip-up"
                  data-aos-delay="400"
                >
                  <div className="number-box">
                    <span className="number">3</span>
                    <span className="number-shadow">3</span>
                  </div>
                  <div className="item-wrap">
                    <div className="icon-box">
                      <img className="store" src={storeIcon} />
                      <p className="digital">Set Up Your Digital Store front</p>
                    </div>
                    <div className="bg-wrap">
                      <div className="traingle"></div>
                      <div id="description3" className="description-box">
                        Post your inventory to the marketplace so qualified buyers
                        can make you offers. Use the recurring post function to ‘set it & forget it’.
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="item-container fourth"
                  data-aos="flip-up"
                  data-aos-delay="600"
                >
                  <div className="number-box">
                    <span className="number">4</span>
                    <span className="number-shadow">4</span>
                  </div>
                  <div className="item-wrap">
                    <div className="icon-box">
                      <img className="coffee" src={coffeeIcon} />
                      <p>Sit Back & Relax</p>
                    </div>
                    <div className="bg-wrap">
                      <div className="traingle"></div>
                      <div id="description4" className="description-box">
                        System will notify you of pending opportunities or offers.
                        Ship, deliver, and upload your paperwork to initiate the
                        payment process.
                      </div>
                    </div>
                  </div>
                </div>
                <div className="btn-container01">
                  <button onClick={signUp}>Register Now</button>
                  <button onClick={contactUs}>Speak To Team</button>
                </div>
              </div>
            </div>

            <section className="CONTAINERS" id="benefits" ref={benefitsRef}>
              <div className="faqcontainer">
                <h2 className="header">And the benefits keep going.</h2>
                <p className="subheader">
                  Dive in and learn more about what PalletTrader can do for you.
                </p>
                <div
                  className="benefits-list"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  {benefits.map((benefit, index) => (
                    <div
                      key={index}
                      className={`accordion-item ${benefit.title === "Reach new markets"
                        ? "reach-new-markets"
                        : ""
                        }`}
                    >
                      <div
                        onClick={() => toggleAccordion(index)}
                        className="accordion-label"
                      >
                        {benefit.title}
                        <span className="toggle-icon">
                          {openIndexes.includes(index) ? "-" : "+"}
                        </span>
                      </div>
                      {openIndexes.includes(index) && (
                        <div className="accordion-content">
                          {benefit.content}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                <div className="buttons-01">
                  <button className="button" onClick={signUp}>
                    REGISTER NOW
                  </button>
                  <button className="button" onClick={contactUs}>
                    SPEAK TO TEAM
                  </button>
                </div>
              </div>
            </section>

            <section className="our_expertise suppliers mb-0">
              <div className="expertise_overlay newsroom" id="founder" ref={founderRef}>
                <div data-aos="fade-right" data-aos-delay="100">
                  <h2>The Founders Circle.</h2>
                  <h2 className="max-w">Ambassadors.</h2>
                  <h2 className="max-w">Trusted Partners.</h2>
                  <p className="max-w">
                    Meet our Founder’s Circle members, the earliest adopters and
                    advocates since PalletTrader’s launch. Click to view and
                    learn more.
                  </p>
                  <div className="grid">
                    <button onClick={founderCircle}>
                      {/* <a href="https://newsroom.pallettrader.com/" target="_blank">
                        GO TO THE NEWSROOM
                      </a> */}
                      MEET THE FOUNDERS CIRCLE
                    </button>
                  </div>
                </div>
              </div>
            </section>

            <section
              className="search_marketplace"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <h2> Register Now. Search the Marketplace. </h2>
              <h2>Experience Innovation.</h2>
              <div className="register">
                <button onClick={signUp}>REGISTER NOW</button>
                <button onClick={contactUs}> SPEAK TO TEAM</button>
              </div>
            </section>
          </Wrapper>
        </Container>
      </PublicLayout>
      <LandingFooter />
    </>
  );
};

export default PalletSupplier;
